import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'badgeSize',
    standalone: false
})
export class BadgeSizePipe implements PipeTransform {
    transform(rawValue: string) {
        const [section, value] = rawValue.split(':');
        const mapPrefix = {
            widths: 'W',
            lengths: 'L'
        };
        return { text: `${mapPrefix[section] ?? ''}${value}`, value: { section, value } };
    }
}
